var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-logo"},[_c('img',{attrs:{"src":_vm.src,"alt":"No Image"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }